// extracted by mini-css-extract-plugin
export default {"container":"SectionLoader_container__xOt-C"};